<template>
	<div class="table-footer">
		<div class="row">
			<div class="col-md-4">
				<span>Show</span>
				<select
					class="form-control"
					v-model="recommendedKeywordShowPerPage"
					id="resultsPerPage"
					@change="showPerPageChanged"
				>
					<option>10</option>
					<option>25</option>
					<option>50</option>
					<option>100</option>
				</select>
				<span>entries</span>
			</div>
			<div class="col-md-4 text-center">
				<!-- <span> Selected Ones</span>
                <button class="btn btn-danger" onclick="deleteCampaignGroup();">
                    <svg viewBox="0 0 8 8" class="icon fill-white">
                            <use
                            xlink:href="images/open-iconic.svg#trash"></use>
                        </svg>
                    Delete
				</button>-->
			</div>
			<div class="col-md-4 text-right">
				<a href="javascript:void(0)" v-if="recommendedKeywordCurrentPageNumber!=1" @click="getPreviousPageList()">Previous</a>
				<select
					class="form-control selectpicker"
					style="max-width:60px;"
					id="brandFilter"
					v-model="recommendedKeywordCurrentPageNumber"
					@change="getNewPageList()"
				>
					<option v-for="index in totalNoOfPages" :key="index" :value="index">{{index}}</option>
				</select>
				<a
					href="javascript:void(0)"
					v-if="recommendedKeywordShowPerPage == keywordList.length"
					@click="getNextPageList()"
				>Next</a>
				<div style="padding-right:0px;padding-top:5px">{{getCount()}}</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "recommendedKeywordFooter",
		data() {
			return {
				totalNoOfPages: 1
			};
        },
		watch: {
			recommendedTotalKeywordCount() {
				this.calculateIndexPerPage();
			}
		},
		computed: {
			recommendedTotalKeywordCount: {
				set(val) {
					(this.$store.state.recommendedTotalKeywordCount = val);
				},
				get() {
					return this.$store.state.recommendedTotalKeywordCount;
				}
			},
			recommendedKeywordShowPerPage: {
				set(val) {
					this.$store.state.recommendedKeywordShowPerPage = val
					sessionStorage.setItem("keyword:recommendedKeywordShowPerPage", val);
				},
				get() {
					if (sessionStorage.getItem("keyword:recommendedKeywordShowPerPage")) {
						return sessionStorage.getItem("keyword:recommendedKeywordShowPerPage");
					}
					else{
						return this.$store.state.recommendedKeywordShowPerPage;
					}
				}
			},
			recommendedKeywordCurrentPageNumber: {
				set(val) {
					this.$store.state.recommendedKeywordCurrentPageNumber = val;
				},
				get() {
					return this.$store.state.recommendedKeywordCurrentPageNumber;
				}
			},
			keywordList() {
				return this.$store.state.recommendedKeywordList;
			}
		},
		mounted() {
			this.calculateIndexPerPage();
		},
		methods: {
			calculateIndexPerPage() {
				this.totalNoOfPages = Math.ceil(
					this.recommendedTotalKeywordCount / this.recommendedKeywordShowPerPage
				);
			},
			getPreviousPageList() {
				if (this.recommendedKeywordCurrentPageNumber <= 1) {
					return;
				} else {
					this.recommendedKeywordCurrentPageNumber -= 1;
                    //this.$store.dispatch("campaign/getCampaignGroupList");
                    this.$emit("showPerPageChanged")
				}
			},
			getNextPageList() {
				this.recommendedKeywordCurrentPageNumber += 1;
                //this.$store.dispatch("campaign/getCampaignGroupList");
                this.$emit("showPerPageChanged")
			},
			getNewPageList() {
                //this.$store.dispatch("campaign/getCampaignGroupList");
                this.$emit("showPerPageChanged")
			},
			getCount() {
				let pageCount = this.recommendedKeywordShowPerPage * (this.recommendedKeywordCurrentPageNumber - 1);
				let extendedcount =
					parseInt(pageCount) + parseInt(this.keywordList.length);
				//return	pageCount+1 + ' to ' + extendedcount;
				return (
					"Showing " +
					(pageCount + 1) +
					" to " +
					extendedcount +
					" results of " +
					this.recommendedTotalKeywordCount
				);
			},
			showPerPageChanged() {
				this.recommendedKeywordCurrentPageNumber = 1;
                this.$emit("showPerPageChanged")
				//this.$store.dispatch("campaign/getCampaignGroupList");
			}
		}
	};
</script>

<style lang="scss">
</style>
